import { log } from "~features/seated-reservation/helpers/stateLogger";
import { BusyState, setState } from "../index";

interface ActionProps {
  state: BusyState;
}

export const setBusyState = (payload: ActionProps) => {
  log("setBusyState", payload);

  return setState({ busyState: payload.state });
};
